<template>
  <div>
    <div
      v-if="!examInfo"
      id="shiyanku"
      style="padding: 60px; background-color: #e6e7ed"
    >
      <div>
        <div style="margin-top: 15px; overflow: hidden">
          <div class="fr">
            <el-button
              id="release"
              @click="
                $router.push({
                  path: '/storetestrecord',
                  query: { plan: 1, type: 2 },
                })
              "
              type="primary"
              >自测记录</el-button
            >
          </div>
        </div>
        <el-row style="margin: auto; width: 1200px" :gutter="30">
          <el-col :span="6" :key="i.name" v-for="i in testList">
            <div class="testListDiv" style="text-align: center">
              <img
                style="cursor: pointer; height: 154px"
                @click="enterExam(i)"
                :src="
                  AppConfig.BASE_URL +
                  'assets/' +
                  (i.subjectid == 1 ? 'physics' : 'chemistry') +
                  '/' +
                  i.thumbnail
                "
                alt=""
              />
              <div
                style="cursor: pointer"
                @click="enterExam(i)"
                class="checkName"
              >
                {{ i.name }}
                <!-- <div class="play-video" @click.stop="playVideo(i)"></div> -->
              </div>
              <!-- 最后一次的测试时间和分数存在一个数组里 lastTestScore-->
              <div class="listTime" v-if="i.score" style="text-align: left">
                <span style="color: #a1a2a5; font-size: 12px"
                  >最近自测：{{ i.test_time }}</span
                >
                <span class="listBottomNum">{{ i.score }}分</span>
              </div>

              <div class="listTime" v-else>
                <span style="color: #a1a2a5; font-size: 12px">暂无提交</span>
              </div>
              <div v-if="vipId" class="maskLayer" @click="getBuyD = true">
                <div
                  style="padding: 0; margin: 50px auto 0; width: 32px"
                >
                  <img
                    src="/static/images/exam/lcok_icon.png"
                    style="margin: 20px 0 0"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-dialog
        title="提示"
        :visible.sync="getBuyD"
        custom-class="nbDialogBuy"
        width="632px"
      >
        <div class="buyDialog">
          <div class="titleWrap">
            <div>您当前为非会员<br/>不能体验实验测评系统</div>
            <div class="titleMess">开通学校版VIP会员立即使用</div>
          </div>
          <div class="btnGroup" @click="openBuy()">
            <div class="btnCont">
              <div class="btnIcon" />
              <div class="btnRight">
                <div class="btnWrap">学校开通</div>
              </div>
            </div>
          </div>
        </div>
        <div @click="getBuyD=false" style="position:absolute;top:0;right:0;cursor: pointer;margin: 10px;">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.4">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9428 16L24.4714 23.5286L23.5286 24.4714L16 16.9428L8.47141 24.4714L7.5286 23.5286L15.0572 16L7.5286 8.4714L8.47141 7.52859L16 15.0572L23.5286 7.5286L24.4714 8.4714L16.9428 16Z" fill="#4D5B71"/>
            </g>
          </svg>
        </div>
      </el-dialog>
    </div>
    <entexam v-else ref="toexam" @goBack="examInfo = false"></entexam>
    <nb-videoplayer
      ref="videoPlayer"
      style="position: absolute; top: 0; left: 0"
      v-show="playing"
      :videotitle="curExam.name"
      :videosrc="curExam.video_url"
      :autocenter="true"
      @close="closeVideo"
    ></nb-videoplayer>
  </div>
</template>
<script>
import { getexpertestinfo, getuserinfo } from "./../../api/exam_api";
import entExam from "./entExam.vue";

export default {
  name: "exprimenta",
  components: {
    entexam: entExam,
  },
  data() {
    return {
      stepTitle:'',
      getBuyD:false,
      testList:[],
      vipId:true,
      vipBuyLink: window.__nb_school_buy,
      examData:{},
      examInfo:false,
      AppConfig2:{},
      AppConfig:{
        // https://imgcdn.nobook.com/exam/resource/addicomponents/v4/build
        // BASE_URL: 'http://addphys.nobook.cc/v1/', // 资源纹理图片相关
        BASE_URL: "https://imgcdn.nobook.com/exam/resource/addicomponents/v11/",
        DATA_BASE_URL: `${window.__nb_api_host || 'https://exam-app.nobook.com'}/api`, // 数据请求相关
        TOKEN: "",
        PID: "EXAMWEBWLuC5K",
        UID: "",
        LOGIN_BASE_URL: window.__nb_passport_api,
        DATAURL: {
          COURSE_INFO: "jiashicoursere/info", // 打开一个实验，获取实验信息
          SAVE_COURSE: "jiashicoursere/saveCourse", // 保存考试数据
          CHART_DATA: "count/countChartData", // 实验分数图表数据
          TEST_LIST: "test/list", // 获取分数测试列表
          TEST_INFO: "test/info", // 测试详情
          ACCOUNT_INFO: "account/info", // 用户基本信息
          GET_VIP: "package/getVipByPackageId", // 获取vip信息
        },
      },
      curExam: {},
      playing: false,
    };
  },
  methods: {
    getBuy() {},
    isVip() {
      if (this.GLOBAL.userInfo.userInfo.vip == 1) {
        this.vipId = false;
      } else {
        this.vipId = true;
      }
    },
    //进入实验
    enterExam($data) {
      this.examInfo = true;
      let that = this;
      this.curExam = $data;
      setTimeout(() => {
        that.$refs.toexam.examClick($data);
      }, 100);
    },
    // 打开购买
    openBuy() {
      window.nbLog.track({
        ExamBuyEntranceClick: {
          button_name: '测评触发立即开通-学校开通',
        },
      });
      window.open(this.vipBuyLink, '_blank');
    },
    playVideo(data) {
      this.curExam = data;
      this.playing = true;
      this.$refs.videoPlayer.play();
    },
    closeVideo() {
      this.playing = false;
      this.$refs.videoPlayer.pause();
    },
    handleFrameMessage({ data }) {
      const { type, payload } = data;
      switch (type) {
        case "PLAY_VIDEO":
          this.playing = true;
          this.$refs.videoPlayer.play();
          break;
        default:
          console.log(`无法识别的指令：${type}`);
      }
    },
  },
  mounted() {
    $(".db-header ").show();
    this.isVip();
    getexpertestinfo({ packageId: this.GLOBAL.productId }).then((res) => {
      if (res.code == 200) {
        res.data.forEach(function (index, i) {
          // res[index].icon_url=res[i].thumbnail
          //   if (index.test_time) {
          //     index.test_time = timestampToTime(index.test_time * 1000);
          //   }
        });
        this.testList = res.data;

        for (let i = 0, _length = res.data.length; i < _length; i++) {
          //图片
          // res.data[i].icon_url = 'http://exam-app.nobook.cc/' + res.data[i].thumbnail;
          // console.log(res.data[i].icon_url);
          //写死的时间
          res.data[i].lastTestScore.addtime = this.GLOBAL.request.toTime(
            res.data[i].lastTestScore.addtime * 1000,
            2
          );
          //最后一次分数
          res.data[i].score = res.data[i].lastTestScore.score;
          res.data[i].test_time = res.data[i].lastTestScore.addtime;
        }
      }
    });
    window.addEventListener("message", this.handleFrameMessage);
  },
  beforeUpdate() {
    if (this.GLOBAL.userInfo.userInfo.vip == 1) {
      this.vipId = false;
    } else {
      this.vipId = true;
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleFrameMessage);
  },
};
</script>
<style scoped>
#shiyanku .maskLayer img {
  min-height: 0;
}
#shiyan {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.checkName {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 58px !important;
  width: 100%;
  box-sizing: border-box;
}
.play-video {
  display: inline-block;
  height: 30px;
  width: 30px;
  margin-left: 5px;
  background-color: chocolate;
  border-radius: 50%;
  vertical-align: middle;
  flex-shrink: 0;
}
.editor-panel {
  left: 50vw;
  top: 50vh;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/ExperimentalLibrary.vue